import { isWindowAvailable } from 'utils/browser';

export const addEventListener = (eventType, callback) =>
  isWindowAvailable ? window.addEventListener(eventType, callback) : null;

export const removeEventListener = (eventType, callback) =>
  isWindowAvailable ? window.removeEventListener(eventType, callback) : null;
